import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import EnvelopeDetailsHeader from './components/EnvelopeDetailsHeader';
import EnvelopeDetailsContent from './components/EnvelopeDetailsContent';

import { useGetEnvelopeDetails } from './hooks/useGetEnvelopeDetails';

const EnvelopeDetailsPage: FC = () => {
  const { t } = useTranslate();
  const { envelopeId } = useParams<{
    societyId: string;
    envelopeId: string;
  }>();

  const {
    data: envelope,
    error,
    actions: { refetch },
  } = useGetEnvelopeDetails(envelopeId);

  if (error || !envelope) {
    return (
      <Page className="bg-lighter pb-5">
        <EmptyStateCard
          mainMessage={t('ErrorLoadingEnvelope')}
          infoMessage={t('ErrorLoadingEnvelopeMessage')}
          bordered={false}
        />
      </Page>
    );
  }

  return (
    <Page className="bg-lighter pb-5">
      <EnvelopeDetailsHeader envelope={envelope} />

      <div className="max-w-4xl mx-auto space-y-6">
        <EnvelopeDetailsContent envelope={envelope} refetchEnvelope={refetch} />
      </div>
    </Page>
  );
};

export default EnvelopeDetailsPage;
